<template>
  <div class="checklist">
    <div v-for="c in items" :key="c.item" class="check-item" :class="c.present ? 'ok' : 'miss'">
      <span class="check-mark">{{ c.present ? '✓' : '✗' }}</span>
      <span class="check-name">{{ c.item }}</span>
      <span class="check-state">{{ c.present ? '已覆盖' : '信息缺失' }}</span>
    </div>
  </div>
</template>

<script>
// 7 项必要章节完整性自检：items = [{item, present}]
export default {
  name: 'SectionChecklist',
  props: {
    items: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.checklist { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 8px; }
.check-item { display: flex; align-items: center; gap: 8px; border-radius: var(--radius-s); padding: 9px 12px; font-size: 12px; border: 1px solid; }
.check-item.ok { background: var(--success-a07); border-color: var(--success-a40); color: var(--success); }
.check-item.miss { background: var(--danger-a07); border-color: var(--danger-a30); color: var(--danger); }
.check-mark { font-weight: 700; }
.check-name { color: var(--text-1); }
.check-state { margin-left: auto; font-size: 11px; }
</style>
